import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setDefaultSavedView: YJSChangeHandler<
  DatabaseChangeType.SET_DEFAULT_SAVED_VIEW
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.defaultViewId = change.viewId;
  });
};
